document.addEventListener('DOMContentLoaded', () => {
    const mainImage = document.querySelector('.about-us-gallery-main-image');
    const thumbnails = document.querySelectorAll('.about-us-gallery-item-img');
    const prevButton = document.querySelector('.controlls-btn.prev');
    const nextButton = document.querySelector('.controlls-btn.next');
  
    let currentIndex = 0;
  
    // Function to update the main image
    const updateMainImage = (index) => {
      const activeThumbnail = document.querySelector('.about-us-gallery-item-img.active');
      if (activeThumbnail) activeThumbnail.classList.remove('active');
      
      thumbnails[index].classList.add('active');
      mainImage.src = thumbnails[index].src;
    };
  
    // Thumbnail click event
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        currentIndex = index;
        updateMainImage(index);
      });
    });
  
    // Previous button click event
    prevButton.addEventListener('click', () => {
      currentIndex = (currentIndex === 0) ? thumbnails.length - 1 : currentIndex - 1;
      updateMainImage(currentIndex);
    });
  
    // Next button click event
    nextButton.addEventListener('click', () => {
      currentIndex = (currentIndex === thumbnails.length - 1) ? 0 : currentIndex + 1;
      updateMainImage(currentIndex);
    });
  });
  